import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgConvertibleBlue = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	width: "24px",
	height: "24px",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "surface1",
		children: [
			/* @__PURE__ */ _jsx("path", {
				style: {
					fill: "none",
					strokeWidth: 1,
					strokeLinecap: "round",
					strokeLinejoin: "round",
					stroke: "currentColor",
					strokeOpacity: 1,
					strokeMiterlimit: 4
				},
				d: "M 18.623292 4.2415 C 19.060792 4.681604 19.060792 5.392542 18.620687 5.832646 C 18.183187 6.27275 17.469646 6.27275 17.029542 5.832646 C 16.589437 5.392542 16.589437 4.681604 17.029542 4.2415 C 17.240479 4.027958 17.526937 3.910771 17.826417 3.910771 C 18.123292 3.910771 18.412354 4.027958 18.623292 4.2415 ",
				transform: "matrix(1.5,0,0,1.5,-8.349,-1.956)"
			}),
			/* @__PURE__ */ _jsx("path", {
				style: {
					fill: "none",
					strokeWidth: 1,
					strokeLinecap: "round",
					strokeLinejoin: "round",
					stroke: "currentColor",
					strokeOpacity: 1,
					strokeMiterlimit: 4
				},
				d: "M 4.265125 18.6335 C 3.827625 18.193396 3.827625 17.482458 4.265125 17.042354 C 4.705229 16.60225 5.418771 16.60225 5.858875 17.042354 C 6.298979 17.482458 6.298979 18.193396 5.858875 18.6335 C 5.647938 18.847042 5.361479 18.964229 5.062 18.964229 C 4.762521 18.964229 4.476063 18.847042 4.265125 18.6335 ",
				transform: "matrix(1.5,0,0,1.5,-1.968,-8.3565)"
			}),
			/* @__PURE__ */ _jsx("path", {
				style: {
					fill: "none",
					strokeWidth: 1,
					strokeLinecap: "round",
					strokeLinejoin: "round",
					stroke: "currentColor",
					strokeOpacity: 1,
					strokeMiterlimit: 4
				},
				d: "M 6.940604 16.436146 C 8.943208 17.769479 11.547375 17.787708 13.568208 16.477812 C 15.586437 15.167917 16.635917 12.785104 16.234875 10.412708 ",
				transform: "matrix(1.5,0,0,1.5,-3.4695,-5.205)"
			}),
			/* @__PURE__ */ _jsx("path", {
				style: {
					fill: "none",
					strokeWidth: 1,
					strokeLinecap: "round",
					strokeLinejoin: "round",
					stroke: "currentColor",
					strokeOpacity: 1,
					strokeMiterlimit: 4
				},
				d: "M 3.090542 10.059896 C 2.671271 7.679688 3.715542 5.28125 5.741583 3.96875 C 7.767625 2.653646 10.384813 2.679688 12.384813 4.033854 ",
				transform: "matrix(1.5,0,0,1.5,-1.503,-1.5)"
			}),
			/* @__PURE__ */ _jsx("path", {
				style: {
					fill: "none",
					strokeWidth: 1,
					strokeLinecap: "round",
					strokeLinejoin: "round",
					stroke: "currentColor",
					strokeOpacity: 1,
					strokeMiterlimit: 4
				},
				d: "M 11 13.416 C 11 13.416 13 12.457667 13 11.017563 L 13 9.369125 L 11.541667 8.843083 C 11.190104 8.718083 10.807292 8.718083 10.455729 8.843083 L 9 9.369125 L 9 11.017563 C 9 12.457667 11 13.416 11 13.416 Z M 11 13.416 ",
				transform: "matrix(1.5,0,0,1.5,-4.5,-4.374)"
			})
		]
	})
});
export default SvgConvertibleBlue;
